import { ReferralRoutingModule } from './referral-routing.module';
import { NgModule } from '@angular/core';

import { ReferralDeclineComponent } from './containers/referral-decline/referral-decline.component';
import { ReferralDeclineImgComponent } from './components/referral-decline-img/referral-decline-img.component';
import { ReferralRedirectComponent } from './containers/referral-redirect/referral-redirect.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [ReferralRoutingModule, SharedModule],
  declarations: [ReferralDeclineComponent, ReferralDeclineImgComponent, ReferralRedirectComponent]
})
export class ReferralModule {}
